// TeamCarousel.js
import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TeamCard from "./TeamCard";
import "./Team.css";
import icon from "./TeamImages/img.webp";
import Uncle from "../../assets/TeamPhotos/Uncle.jpg";
import Dada from "../../assets/TeamPhotos/Dada.jpg";
import Chilli from "../../assets/TeamPhotos/Chilli.jpg";
import Frooty from "../../assets/TeamPhotos/Frooty.jpg";

// Carousel Wrapper
const CarouselContainer = styled.div`
  width: 85%;
  margin: 0 auto;
  @media (max-width: 768px) {
    width: 90%;
  }
`;

// Slick Arrow Customization
const Arrow = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 1.5em;
  cursor: pointer;
  z-index: 1;
`;

// Next Arrow
export const NextArrow = (props) => {
  const { className, onClick } = props;
  return <Arrow className={className} onClick={onClick}></Arrow>;
};

// Prev Arrow
export const PrevArrow = (props) => {
  const { className, onClick } = props;
  return <Arrow className={className} onClick={onClick}></Arrow>;
};

const TeamCarousel = ({ isTestemonials }) => {
  const teamMembers = isTestemonials
    ? [
        {
          name: "Bhairunaath Pashuahar and Kirana Bhandar",
          designation: "Rajnagar, Since 2002",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I've had the pleasure of working with Adarsh Industries for over 22 years now. As the owner of Bhairunaath Pashuahar and Kirana Bhandar in Rajnagar, I've seen firsthand the impact that their high-quality cattle feed has had on my business.

Their products have been a game-changer for us. Our livestock has never been healthier, and our business has never been stronger. But it's not just about the products - it's about the people behind them. The team at Adarsh Industries has always been responsive, knowledgeable, and courteous.

I've worked with a lot of suppliers over the years, but Adarsh Industries is more than just a supplier - they're a partner. They've taken the time to understand my unique needs and challenges, and they've worked closely with me to develop tailored solutions.

If you're looking for a partner who truly cares about your business, look no further than Adarsh Industries. They're a company that's dedicated to helping you succeed, and I'm honored to have them as part of my journey.`,
        },
        {
          name: "Dhamani Brothers",
          designation: "Nevai, Since 2007",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I'm thrilled to share our experience with Adarsh Industries, a partnership that's been thriving for over 15 years. As the co-owner of Dhamani Brothers in Nevai, I've had the pleasure of working with their team since 2007.

Their cattle feed has been a cornerstone of our business, providing our livestock with the nutrients they need to thrive. But what sets Adarsh Industries apart is their unwavering commitment to quality, customer satisfaction, and innovation.

Their team has always been responsive, knowledgeable, and courteous, addressing our needs and concerns promptly. They've taken the time to understand our unique challenges and goals, and have worked closely with us to develop tailored solutions.

I wholeheartedly recommend Adarsh Industries to anyone seeking a reliable partner in cattle nutrition. Their dedication to excellence, customer satisfaction, and innovation has earned them a reputation as one of the best in the industry.`,
        },
        {
          name: "Shree Krishna Trading Company",
          designation: "Chaksu, Since 2007",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I've been working with Adarsh Industries for over 17 years now, and I can honestly say it's been a game-changer for my business. As the owner of Shree Krishna Trading Company in Chaksu, I've seen firsthand the impact that their high-quality cattle feed has had on our livestock.

Their team has always been super responsive and knowledgeable, taking the time to understand our unique needs and challenges. They've worked closely with us to develop tailored solutions that have really helped us grow our business.

What I appreciate most about Adarsh Industries is their commitment to quality and customer satisfaction. They're not just suppliers - they're partners who genuinely care about our success.

If you're looking for a reliable partner in cattle nutrition, I highly recommend Adarsh Industries. They're the real deal!"
`,
        },
        {
          name: "Kishan Sahay Hanuman Baksh Madhani",
          designation: "Chomu, Since 2007",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `As a large scale farmer in Chomu, I've been relying on Adarsh Industries' cattle feed since 2007. Their products have consistently improved the health and productivity of my livestock. The quality of their feed is exceptional, and it's evident in the robust growth and milk yield of my cows. I'm truly grateful for the positive impact Adarsh Industries has had on my farming business.`,
        },
        {
          name: "Shiv Trading Company",
          designation: "Kakroli, Since 2010",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I'm proud to say that Shiv Trading Company has been associated with Adarsh Industries since 2010. As a trader from Kakroli, I've seen firsthand the impact that high-quality cattle feed can have on our business.

Adarsh Industries has been a rock-solid partner, providing us with exceptional products, technical expertise, and unparalleled customer service. Their cattle feed has consistently delivered outstanding results, improving the health, growth, and productivity of our livestock.

What sets Adarsh Industries apart is their commitment to building long-term relationships. They've taken the time to understand our unique needs, challenges, and goals, and have worked closely with us to develop tailored solutions.

I wholeheartedly recommend Adarsh Industries to anyone seeking a reliable partner in cattle nutrition. Their dedication to excellence, customer satisfaction, and innovation has earned them a reputation as one of the best in the industry.`,
        },
        {
          name: "Ramswaroop Ramavtar Jain",
          designation: "Malpura, Since 2015",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I still remember the day we started working with Adarsh Industries back in 2015. We were looking for a reliable partner to help us improve our cattle's health and productivity.

Over the years, I've been consistently impressed with the quality of their feed and the expertise of their team. They've been more than just suppliers - they've been trusted advisors, always willing to lend a helping hand or offer valuable advice.

Their feed has made a real difference to our livestock, and we've seen significant improvements in their health and growth. But it's not just about the products - it's about the relationships we've built and the trust we've established.

I'd wholeheartedly recommend Adarsh Industries to anyone looking for a reliable partner in cattle nutrition. They're a company that truly cares about their customers and is dedicated to helping them succeed.`,
        },
        {
          name: "Sharma Traders ",
          designation: "Deedwana Lalsoth, Since 2015",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I'm proud to say that Sharma Traders has been associated with Adarsh Industries since 2015. As a trader from Deedwana, I've seen firsthand the impact that high-quality cattle feed can have on our business.

Adarsh Industries has been more than just a supplier - they've been a trusted partner. Their team has always been willing to lend a helping hand, offer expert advice, and go the extra mile to ensure we're completely satisfied.

Their cattle feed has been a game-changer for us. We've seen significant improvements in our livestock's health, growth, and productivity. And with Adarsh Industries' technical support team behind us, we know we can always count on them to help us overcome any challenges.

I wholeheartedly recommend Adarsh Industries to anyone looking for a reliable partner in cattle nutrition. They're a company that truly cares about their customers and is dedicated to helping them succeed.`,
        },
        {
          name: "Ganpati Traders",
          designation: "Kishangarh, Since 2015",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `I still remember the day we started working with Adarsh Industries back in 2000. As a trader from Kishangarh, I was looking for a reliable partner to help me grow my business.

Over the years, I've seen Adarsh Industries grow and evolve, but one thing has remained constant - their commitment to quality, customer satisfaction, and innovation. Their cattle feed has been a game-changer for us, and their technical support team has been invaluable in helping us optimize our feeding strategies.

What I appreciate most about Adarsh Industries is their willingness to listen, adapt, and improve. They've been more than just suppliers - they've been trusted friends, always willing to lend a helping hand or offer expert advice.

If you're looking for a partner who truly cares about your business, look no further than Adarsh Industries. They're a company that's dedicated to helping you succeed, and I'm honored to have them as part of my journey.`,
        },
        {
          name: "Anjali Trading Company",
          designation: "Beawar, Since 2020",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `We, at Anjali Trading Company, have had an outstanding experience with Adarsh Industries over the past five years. Their cattle feed has consistently delivered exceptional quality, nutrition, and results.

We appreciate Adarsh Industries' commitment to customer satisfaction, technical support, and timely delivery. Their professionalism, integrity, and transparency have earned our trust and loyalty.

We highly recommend Adarsh Industries to anyone seeking top-quality cattle feed and a reliable partnership.`,
        },
        {
          name: "Ganesh Trading Company",
          designation: "Udaipur, Since 2022",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `At Ganesh Trading Company, we've experienced a significant improvement in our livestock's health and productivity since partnering with Adarsh Industries in 2022. Their cattle feed is of exceptional quality, with optimal nutritional value, palatability, and freshness.

We're impressed by Adarsh Industries' commitment to customer satisfaction, timely delivery, and expert technical support. Their team is responsive, knowledgeable, and courteous, always willing to address our queries and concerns.

Adarsh Industries has earned our trust and loyalty. We highly recommend them to anyone seeking top-notch cattle feed and a reliable supplier.`,
        },
      ]
    : [
        {
          image: Dada,
          name: "MR. DHANESHWAR PRASAD GOEL",
          designation: "MANAGING DIRECTOR",
          intro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a str`,
          detailedIntro: `Mr. Dhaneshwar Prasad Goel, aged 85, is a seasoned professional with an illustrious career spanning over 40 years in government service as an Executive Engineer in the Public Works Department (PWD). His extensive experience in the public sector laid a strong foundation for his next venture into entrepreneurship.
After retiring from government service, Mr. Goel, along with his son, embarked on a new journey by establishing Adarsh Industries, a leading cattle feed manufacturing company. At Adarsh Industries, he plays a pivotal role in overseeing the overall operations of various departments, ensuring smooth and efficient functioning across the organization.
His key responsibilities include managing the company’s accounting and financial aspects, ensuring fiscal discipline, and guiding strategic financial decisions. In addition to handling the finances, Mr. Goel also supervises the manufacturing unit, leveraging his vast experience to maintain high standards of production and quality control.`,
        },
        {
          image: Uncle,
          name: "MR. VIJAY GOYAL",
          designation: "CEO AND BUSINESS HEAD",
          intro: `Mr. Vijay Goyal is a visionary leader with a passion for the cattle feed industry. He has been at the helm of Adarsh Industries for over 25 years, guiding the company to become a respected name in the market. Mr. Goyal is more than just a CEO; he's a driving force behind the company's success.`,
          detailedIntro: `Mr. Vijay Goyal is a visionary leader with a passion for the cattle feed industry. He has been at the helm of Adarsh Industries for over 25 years, guiding the company to become a respected name in the market.
Mr. Goyal is more than just a CEO; he's a driving force behind the company's success. He's personally involved in every aspect of the business, from ensuring the quality of the feed to developing innovative marketing strategies. His deep understanding of the industry and his commitment to excellence are evident in everything Adarsh Industries does.
Mr. Goyal is a hands-on leader who inspires his team to strive for greatness. He's always looking for ways to improve the company and to better serve its customers. His passion for the industry and his dedication to his work are contagious, and they've helped Adarsh Industries become a leader in its field.`,
        },
        {
          image: Chilli,
          name: "Mr. NIDHISH GOYAL",
          designation: "MARKETING HEAD",
          intro: `Mr. Nidhish Goyal is the Marketing Head at Adarsh Industries, bringing his expertise to the company for the past two years. As a strategic leader, he is responsible for overseeing all marketing processes and activities, driving brand awareness, and fostering customer relationships. Mr. Goyal is a`,
          detailedIntro: `Mr. Nidhish Goyal is the Marketing Head at Adarsh Industries, bringing his expertise to the company for the past two years. As a strategic leader, he is responsible for overseeing all marketing processes and activities, driving brand awareness, and fostering customer relationships.
      Mr. Goyal is a skilled professional with a proven track record in developing and implementing effective marketing campaigns. His expertise in [specific marketing areas, e.g., digital marketing, brand management, market research] has been instrumental in positioning Adarsh Industries as a leading player in the cattle feed industry.`,
        },
        // {
        //   image: icon,
        //   name: "Other Team Members",
        //   designation: "Staff",
        //   intro:
        //     "Mr. Pareek ji, Mr. Pareek ji, Mr. Pareek ji, Mr. Pareek ji, Mr. Pareek ji",
        //   staffList: [
        //     "KRISHN KUMAR PAREEK, MARKETING MANAGER (8 years).",
        //     "KAMAL SHARMA, MARKETTING MANAGER (1.5+ years).",
        //     "OTHER STAFF- 2 supervisors, 1 lab assistant, 15 labours.",
        //   ],
        // },
      ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <CarouselContainer>
      <Slider {...settings}>
        {teamMembers.map((member, index) => (
          <TeamCard
            isTestemonials={isTestemonials}
            key={index}
            member={member}
            staffCard={member.designation == "Staff"}
          />
        ))}
      </Slider>
    </CarouselContainer>
  );
};

export default TeamCarousel;
